import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";

import Chatbox from "./pages/Chatbox";
import LegalPage from "./pages/LegalPage";
import UtilisationVinomiam from "./pages/UtilisationVinomiam";
import "./index.css";
import "./styles/Chatbox.css";
import VinDetails from "./pages/VinDetails";
import Historique from "./pages/Historique";

// --------- Composant App ---------
function App() {

    // Correction globale pour la taille du viewport et gestion du clavier mobile
    useEffect(() => {
        const handleViewportAdjustments = () => {
            const setViewportHeight = () => {
                const vh = window.innerHeight * 0.01; // Calcul de 1% de hauteur visible
                document.documentElement.style.setProperty("--vh", `${vh}px`);
            };

            const handleFocusBlur = () => {
                // Événement lorsqu'un élément reçoit/retire le focus (clavier visible ou non)
                const inputs = document.querySelectorAll("input, textarea, select");
                inputs.forEach((input) => {
                    input.addEventListener("focus", () => {
                        document.body.classList.add("keyboard-open");
                    });
                    input.addEventListener("blur", () => {
                        document.body.classList.remove("keyboard-open");
                        setTimeout(() => setViewportHeight(), 300); // Recalibrer après fermeture du clavier
                    });
                });
            };

            setViewportHeight(); // Configurer le viewport initial
            window.addEventListener("resize", setViewportHeight); // Ajustement à chaque redimensionnement
            handleFocusBlur(); // Gestion du focus du clavier

            return () => {
                window.removeEventListener("resize", setViewportHeight);
            };
        };

        handleViewportAdjustments();
    }, []);

    return (
        <div className="app-container">
            <Routes>
                <Route path="/" element={<Chatbox/>}/>
                {/* Pages légales */}
                <Route path="/mentions-legales" element={<LegalPage/>}/>
                <Route path="/utilisation-vinomiam" element={<UtilisationVinomiam/>}/>
                <Route path="/vin/:type/:id" element={<VinDetails />} />
                <Route path="/historique" element={<Historique />} />
            </Routes>
        </div>
    );
}

export default App;